var config = {}

let port = ''
if ('116.62.66.74' === location.hostname) {
	port = ':9208'
}

const isDev = process.env.NODE_ENV === 'development'

if (isDev) {
	// npm run dev：本地后端默认 9209
	config.host = location.protocol + '//' + location.hostname + ':9209/manage/api'
	config.webImg = location.protocol + '//' + location.hostname + ':9209/manage'

	// config.host = 'http://cgmedev.hfrjkf.cn' + '/manage/api'
	// config.webImg = 'http://cgmedev.hfrjkf.cn' + '/manage'
} else {
	// npm run build 发布：同域名访问，特殊 IP 走 9208
	config.host = location.protocol + '//' + location.hostname + port + '/manage/api'
	config.webImg = location.protocol + '//' + location.hostname + port + '/manage'
}


console.log(config);
export default config


// WEBPACK FOOTER //
// ./src/utils/config.js